import { setConsent } from "@/lib/track";

export const CookieBanner = ({ tracking, privacyHref, onDone }) => {
  const choose = (v) => { setConsent(v, tracking); onDone(); };
  return (
    <div role="region" aria-label="Cookie consent" className="fixed inset-x-3 bottom-3 z-[70] mx-auto max-w-xl rounded-md border border-[#A49342]/50 bg-[#1A2817]/95 p-5 shadow-2xl backdrop-blur-xl sm:bottom-6" data-testid="cookie-banner">
      <p className="font-display text-lg text-[#C9B465]">Tickets, please</p>
      <p className="font-body mt-1 text-[15px] leading-relaxed text-[#FFF7F0]/90">
        We would like to use analytics and advertising cookies to understand how passengers find us. They only load if you say yes. <a href={privacyHref} className="underline underline-offset-4 decoration-[#A49342]">Privacy policy</a>
      </p>
      <div className="mt-4 flex gap-2">
        <button type="button" onClick={() => choose("granted")} className="btn-gold font-display min-h-[44px] flex-1 rounded-full px-5 tracking-wider" data-testid="cookie-accept-button">Accept</button>
        <button type="button" onClick={() => choose("denied")} className="btn-ghost font-display min-h-[44px] flex-1 rounded-full px-5 tracking-wider" data-testid="cookie-reject-button">Reject</button>
      </div>
    </div>
  );
};
